<div class="gap-lg flex flex-col">
  <h3 class="text-base font-semibold">
    {{ data().title }}
  </h3>

  <section class="gap-x-xl gap-y-xs grid grid-cols-[auto_1fr] text-sm">
    @for (item of data().attributes; track $index) {
      <span [class.whitespace-nowrap]="!item.wrap">
        {{ item.label }}
      </span>
      @if (item.href) {
        <a [href]="item.href" class="font-semibold underline" [class.whitespace-nowrap]="!item.wrap">
          {{ item.value }}
        </a>
      } @else if (item.link; as link) {
        <div class="gap-xs flex flex-col items-start">
          @if (item.value) {
            <span class="font-semibold" [class.whitespace-nowrap]="!item.wrap">
              {{ item.value }}
            </span>
          }
          <button type="button" class="bx-link gap-xs flex cursor-pointer items-center whitespace-nowrap" (click)="link.action()">
            <svg-icon [key]="link.icon" fontSize="20px"></svg-icon>
            {{ link.label }}
          </button>
        </div>
      } @else if (item.badge; as badge) {
        <bxi-status-badge [cardinality]="badge.cardinality" [message]="badge.tooltip" size="sm" [iconOnly]="true"></bxi-status-badge>
      } @else if (item.lines; as lines) {
        <div class="gap-xs flex flex-col">
          @for (line of lines; track $index) {
            <span class="font-semibold">{{ line }}</span>
          }
        </div>
      } @else {
        <span class="font-semibold" [class.whitespace-nowrap]="!item.wrap">
          {{ item.value }}
        </span>
      }
    }
  </section>
</div>
